import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
export const Route = createFileRoute('/_auth/settings/users')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const currentTab = location.pathname.split('/').pop()

  const handleChange = (value) => {
    navigate({
      to: `/settings/users/${value}`,
    })
  }
  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-hidden">
      <Tabs
        value={currentTab || 'members'}
        onValueChange={handleChange}
        className="sticky top-0 w-full"
      >
        <TabsList className="mb-2">
          <TabsTrigger value="members">Chuyên viên</TabsTrigger>
          <TabsTrigger value="departments">Bộ phận</TabsTrigger>
          <TabsTrigger value="organizations">Tổ chức</TabsTrigger>
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  )
}
